/**
 * Generate a UUID v4
 * From https://stackoverflow.com/a/8809472
 *
 * An UUID v4 should looks like this: 6ddfc68e-fc20-4173-a749-55ff60834f12
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "generateUUID", {
    enumerable: true,
    get: function() {
        return generateUUID;
    }
});
var generateUUID = function() {
    var now = Date.now();
    // Time in microseconds since page-load or 0 if unsupported
    var microSec = window.performance && performance.now && performance.now() * 1000 || Math.random() * 100000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(char) {
        var rand = Math.random() * 16 // random number between 0 and 16
        ;
        if (now > 0) {
            // Use timestamp until depleted (offset random value with hex portion from timestamp)
            rand = Math.floor((now + rand) % 16);
            now = Math.floor(now / 16);
        } else {
            // Use microseconds since page-load (offset random value with hex portion from timestamp)
            rand = Math.floor((microSec + rand) % 16);
            microSec = Math.floor(microSec / 16);
        }
        return (char === "x" ? rand : rand % 4 + 8).toString(16);
    });
};

//# sourceMappingURL=uuidV4.js.map